import MandalaDivider from "@/components/MandalaDivider";

/**
 * Lightweight, imageless page header used across content pages.
 * Sits below the site header with a warm ivory background,
 * eyebrow label, large serif title and a mandala divider.
 */
export default function PageHeader({ eyebrow, title, sub, titleClassName }) {
  return (
    <section
      data-testid="page-header"
      className="relative bg-[#FDFBF7] border-b border-[#E5DAC7]/60"
    >
      {/* soft sandalwood glow */}
      <div
        className="pointer-events-none absolute inset-0 opacity-70"
        style={{
          background:
            "radial-gradient(60% 90% at 50% 0%, rgba(212,175,55,0.10) 0%, rgba(212,175,55,0) 60%)",
        }}
      />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-14 lg:pt-20 lg:pb-16 text-center">
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        <h1 className={`mt-4 font-display text-4xl sm:text-5xl lg:text-6xl text-[#2A2118] leading-[1.05] ${titleClassName || ""}`}>
          {title}
        </h1>
        {sub && (
          <p className="mt-5 text-[15.5px] text-[#5C4D42] max-w-2xl mx-auto leading-relaxed">
            {sub}
          </p>
        )}
        <div className="mt-7 flex justify-center">
          <MandalaDivider />
        </div>
      </div>
    </section>
  );
}
